module.exports = __webpack_public_path__ + "img/voice-message.c3a2642b.webp";